import { HiEllipsisVertical } from "react-icons/hi2";

export const DotsIcon = ({ width, height, color, ...props }) => (
  <HiEllipsisVertical
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
